type GuaranteeListeningType = {
  cd: boolean
  vinyl: boolean
  analog: boolean
  digital: boolean
  streaming: boolean
}

type GuaranteeFindType = {
  anzeige: boolean
  artikel: boolean
  internet: boolean
  sonstiges: string
  autorisierter: boolean
}

export enum GuaranteeStatusEnum {
  RECEIVED = 'RECEIVED',
  CONFIRMED = 'CONFIRMED',
}

export type GuaranteeType = {
  guaranteeNumber: string
  customerName: string
  customerEmail: string
  serialNumber: string
  shopName: string
  city: string
  country: string | null
  music: GuaranteeListeningType
  component: string
  stars: number
  find: GuaranteeFindType
  invoiceFile: string
  creationDate: string
  warrantyYears: number
  guaranteeStatus: GuaranteeStatusEnum
  language: string
  purchaseDate?: Date
  acceptanceRegulationsCheckboxOne?: boolean
  acceptanceRegulationsCheckboxTwo?: boolean
}
